"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialPaymentsExtendedSchema = void 0;
var partial_payment_schema_1 = require("./partial-payment-schema");
exports.partialPaymentsExtendedSchema = __assign(__assign({}, partial_payment_schema_1.partialPaymentsSchema), { allOf: [
        {
            if: {
                not: {
                    properties: {
                        receivedAmount: {
                            const: 0,
                        },
                    },
                },
            },
            else: {
                properties: {
                    receivedAmount: {
                        oneOf: [
                            {
                                properties: {
                                    receivedAmount: {
                                        minimum: 1,
                                        maximum: 9999999999999,
                                        type: 'number',
                                        decimal: [15, 2],
                                    },
                                },
                            },
                            {
                                properties: {
                                    receivedAmount: {
                                        minimum: -9999999999999,
                                        maximum: -1,
                                        type: 'number',
                                        decimal: [15, 2],
                                    },
                                },
                            },
                        ],
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    receivedDate: {
                        enum: [null, undefined, ''],
                    },
                },
            },
            else: {
                required: ['receivedAmount'],
            },
        },
        {
            if: {
                properties: {
                    receivedAmount: {
                        enum: [null, undefined, ''],
                    },
                },
            },
            else: {
                required: ['receivedDate'],
            },
        },
    ] });
